import styled, { keyframes } from "styled-components";
import ProgressiveImg from "../../../../components/ProgressiveImg/ProgressiveImg";
import Draggable from "react-draggable";
import { ReactComponent as LeftArrow } from "../../../../assets/icons/chevron-left.svg";

import { ReactComponent as Xsvg } from "../../../../assets/icons/close.svg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const MainContainer = styled.div`
  flex-direction: ${(props) => (props.$column ? "column" : "row")};
  background: #f6f6f9;
  min-height: 100dvh;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  align-items: center;
  position: relative;
  padding: 4rem 4rem 8rem 4rem;

  margin-top: 140px;
  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 1200px) {
    margin-top: 126px;
  }
  @media (max-width: 870px) {
    margin-top: 79px;
    padding: 2rem 2rem 8rem 2rem;
  }
  @media (max-width: 380px) {
    margin-top: 65px;
  }
`;
export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  justify-content: center;
`;
export const SectionTitle = styled.h1`
  font-family: "Avenir-Medium";
  font-size: 1.6rem;
  user-select: none;
  letter-spacing: 0.067px;
`;

export const ChevronDown = styled(LeftArrow)`
  rotate: -90deg;
  @media (max-width: 1406px) {
    rotate: 180deg;
  }
`;
export const ChevronTop = styled(LeftArrow)`
  rotate: 90deg;
  @media (max-width: 1406px) {
    rotate: 0deg;
  }
`;
export const ChevronRight = styled(LeftArrow)`
  rotate: 180deg;
`;
export const ChevronLeft = styled(LeftArrow)``;

export const Layout = styled.div`
  height: 100%;
  min-height: 100dvh;
  display: flex;

  flex-direction: column;
  align-items: ${(props) =>
    props.$loading ? "center" : props.$loggedIn ? "center" : "flex-start"};
  margin-top: ${(props) => (!props.$loggedIn ? "-6rem" : "0rem")};
  transition: all 0.3s ease-in-out;
  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "10rem 30rem 10rem 4rem"
          : "10rem 4rem 10rem 30rem"
        : !props.$ar
        ? "10rem 4rem 10rem 10rem"
        : "10rem 10rem 10rem 4rem"
      : "10rem 4rem"};

  @media (max-width: 1475px) {
    width: ${(props) => (!props.$loggedIn ? "unset" : "100%")};
  }
  @media (max-width: 870px) {
    padding: ${(props) =>
      !props.$loggedIn ? "4rem 4rem 10rem 4rem" : "10rem 4rem"};
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  flex-wrap: ${(props) => (props.$noWrap ? "nowrap" : "wrap")};
`;

export const SuggestedRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
  @media (max-width: 1005px) {
    overflow: hidden;
    max-width: calc(209.69px * 2 + 2rem);
  }
`;

export const SuggestRelative = styled.div`
  position: relative;
  width: fit-content;
`;

export const SuggestedItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  margin-top: 3rem;
`;
export const SuggestItem = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: column;
  gap: 1.5rem;
  min-width: 23.3rem;
  max-width: 23.3rem;
  transition: all 0.2s ease-in-out;
  &:hover {
    scale: 0.975;
  }

  &:active {
    scale: 1;
  }
`;
export const SuggestItemPhoto = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  object-fit: contain;
  user-select: none;
  width: 100%;
  height: 30rem;
`;
export const SuggestItemName = styled.span`
  color: #636060;
  font-family: "Avenir-Black";
  font-size: 1.6rem;
  font-weight: "700";
  letter-spacing: 0.5px;
`;
export const SuggestItemPrice = styled.span`
  color: #636060;
  font-family: "Avenir-Medium";
  font-size: 1.7rem;
  font-weight: "400";
`;
export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

export const ImageColumn = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 1rem;
  width: 13rem;
  position: relative;

  @media (max-width: 1406px) {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }
`;

export const Buttons = styled.div`
  display: flex;
  margin-top: 3rem;
  flex-direction: column;
  gap: 1.5rem;
  @media (max-width: 1406px) {
    display: none;
  }
`;

export const StyledButtons = styled.div`
  display: none;
  margin-top: 3rem;
  flex-direction: column;
  gap: 1.5rem;
  @media (max-width: 1406px) {
    display: flex;
  }
`;

export const StyledColumn = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 1rem;
  max-width: 55rem;
  position: relative;
  @media (max-width: 1130px) {
    margin-top: 2rem;
  }
  @media (max-width: 1020px) {
    width: 100%;
  }
`;

export const OldColumn = styled.div`
  display: flex;

  flex-direction: column;
  gap: 1rem;
  position: relative;
  align-items: center;

  height: 60rem;
  width: 76.5rem;
  justify-content: center;
  background-color: #f9f9f9;
  border-radius: 1.5rem;
  @media (max-width: 1132px) {
    width: 100%;
    height: 100%;
  }
`;

export const Card = styled.div`
  display: flex;
  position: relative;
  width: 59rem;
  align-items: center;
  padding: ${(props) => (props.$bigGap ? "4rem" : "1.5rem")};
  justify-content: center;
  min-height: 82.23rem;
  height: 100%;

  @media (max-width: 1510px) {
    width: 49rem;
  }
  @media (max-width: 850px) {
    min-height: fit-content;
  }
  @media (max-width: 1020px) {
    padding: ${(props) => (props.$bigGap ? "4rem 3rem" : "4rem 1.5rem")};

    width: 90%;
    min-height: fit-content;
  }

  @media (max-width: 520px) {
    padding: ${(props) => (props.$bigGap ? "3rem" : "1.5rem")};
  }
`;

export const StyledCard = styled(Card)`
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 30px;
  justify-content: flex-start;
`;
export const FooterCard = styled.div`
  display: flex;
  width: 59rem;
  align-items: center;
  padding: 12px;
  justify-content: center;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  min-height: 11.2rem;
  gap: 4rem;

  @media (max-width: 1510px) {
    width: 49rem;
  }
  @media (max-width: 1020px) {
    padding: 4rem 2rem;
    width: 90%;
    height: fit-content;
  }
  @media (max-width: 610px) {
    flex-direction: column;
  }
`;
export const Img = styled(ProgressiveImg)`
  user-select: none;
  border-radius: 1rem;
  width: auto;
  height: auto;
  object-fit: contain;
  pointer-events: none;
  max-height: 60rem;
  max-width: 76.5rem;
  background-color: #f9f9f9;
  @media (max-width: 1020px) {
    width: 100%;
  }
`;

export const StyledImg = styled(ProgressiveImg)`
  user-select: none;
  background-color: #f9f9f9;
  border-radius: ${(props) => (props.$small ? "1.5rem" : "1rem")};

  cursor: ${(props) => (props.$small ? "pointer" : "default")};
  width: ${(props) => (props.$small ? "13rem" : "55rem")};
  height: ${(props) => (props.$small ? "13rem" : "55rem")};
  object-fit: ${(props) => (props.$contain ? "contain" : "cover")};
  transition: all 0.2s ease-in-out;

  background-color: #f9f9f9;
  &:hover {
    scale: ${(props) => (props.$small ? 0.975 : 1)};
  }
  &:active {
    scale: 1;
    filter: ${(props) => (props.$small ? "brightness(80%)" : "none")};
  }

  @media (max-width: 600px) {
    width: ${(props) => (props.$small ? "calc((100% - 4.5rem) / 4)" : "100%")};
    aspect-ratio: 1 / 1;
    height: auto;
  }
`;
export const PhotosColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-height: calc(55.3rem + 1.5rem);
  overflow: hidden;

  @media (max-width: 1406px) {
    flex-direction: row;
    width: 100%;
  }
`;

export const ChevronContainerSuggest = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 10;
  position: absolute;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;

  cursor: pointer;

  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(5px);

  top: 50%;
  transform: translateY(-50%);
  right: ${(props) => (!props.$left ? "-1.5rem" : "unset")};
  left: ${(props) => (props.$left ? "-1.5rem" : "unset")};

  @media (max-width: 1315px) {
    display: flex;
  }
`;

export const ChevronContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  bottom: ${(props) => (props.$top ? "unset" : "-1.5rem")};
  top: ${(props) => (!props.$top ? "unset" : "-1.5rem")};
  cursor: pointer;

  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(5px);

  @media (max-width: 1406px) {
    top: 50%;
    bottom: unset;
    transform: translateY(-50%);

    left: ${(props) => (props.$top ? "-1.5rem" : "unset")};
    right: ${(props) => (!props.$top ? "-1.5rem" : "unset")};
  }
`;

export const Plus = styled.span`
  color: #636060;
  font-family: "Avenir-Medium";
  font-size: 1.6rem;
  font-weight: "700";
  width: 6.1rem;
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
  justify-content: center;
`;
export const Quantity = styled.input`
  color: #212b36;
  font-size: 2rem;
  font-weight: "500";
  font-family: "Avenir-Medium";
  width: 12.7rem;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #707070;
  border-right: 1px solid #707070;

  justify-content: center;
`;
export const Minus = styled(Plus)``;
export const QuantityContainer = styled.div`
  display: flex;
  border: 1px solid #707070;
  flex-direction: row;
  width: 25rem;
  border-radius: 0.4rem;
  height: 5rem;
`;
export const Name = styled.span`
  font-family: "FrankfurterEF-Medium";
  font-size: 2.8rem;
  letter-spacing: 0.067px;
  color: #212b36;
`;
export const Price = styled.span`
  font-weight: "400";
  font-family: "Avenir-Medium";
  font-size: 2.4rem;
  letter-spacing: 0.067px;
  color: #212b36;
`;
export const Title = styled.span`
  color: #636060;
  font-family: "Avenir-Black";
  font-size: 1.9rem;
  font-weight: "700";
  letter-spacing: 1px;
  text-transform: uppercase;
`;
export const ItemInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (max-width: 1020px) {
    margin-top: 2rem;
  }
`;

export const Description = styled.span`
  font-family: "Avenir-Medium";
  font-size: ${(props) => (props.$small ? "1.5rem" : "1.8rem")};
  font-weight: "400";
  color: #636060;
`;

export const Label = styled.span`
  font-family: "Avenir-Medium";
  font-size: 1.6rem;
  font-weight: "400";
  color: #636060;
  text-transform: uppercase;
`;
export const Line = styled.div`
  width: 100%;
  height: 1px;
  margin: 1.7rem 0rem;
  background-color: #e7e4e4;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;

export const Color = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  transition: all 0.2s ease-in-out;
  &:hover {
    scale: 1.1;
    opacity: 1 !important;
  }
`;
export const ChooseFile = styled.input`
  background-color: red;
  position: absolute;
  left: 0;
  border-radius: 1rem;
  width: 100%;
  opacity: 0;
  height: 100%;

  top: 0;
`;
export const Size = styled(Color)`
  background-color: #484888;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GiftCardSub = styled(Color)`
  background-color: #484888;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  width: 130px;
  height: 120px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;
export const SizeValue = styled.span`
  user-select: none;
  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 1rem;
  margin-bottom: -2px;
  text-transform: uppercase;
`;
export const PriceValue = styled.span`
  user-select: none;
  color: #fff;
  margin-bottom: -2px;
  font-family: "FrankfurterEF-Medium";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.067px;
`;
export const Colors = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
`;

export const ButtonRow = styled.div`
  position: relative;
`;
export const ButtonsContainer = styled.div`
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 1rem;
  display: flex;
  flex-wrap: wrap;
`;
export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ImageRelative = styled.div`
  position: relative;
  min-height: 56.8rem;

  @media (max-width: 1406px) {
    flex-direction: row;
    min-height: unset;
    min-width: 508.5px;
  }
  @media (max-width: 600px) {
    min-width: 100%;
  }
`;

export const Relative = styled.div`
  position: relative;
`;

export const MinQuantityContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
`;
export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
export const Button = styled.button`
  border-radius: 0.4rem;
  width: 30rem;
  height: 5rem;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #484888;
  border: none;
  outline: none;

  cursor: pointer;
  user-select: none;
  color: #fff;
  text-align: center;
  font-family: "Avenir-Medium";
  font-weight: "500";
  font-size: 2rem;
  letter-spacing: 1px;

  transition: all 0.3s ease-in-out;

  &:active {
    scale: 0.97;
  }
`;

export const UploadButton = styled.button`
  width: 30rem;
  height: 5rem;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #484888;
  background: #fff;
  outline: none;
  cursor: pointer;
  user-select: none;
  color: #484888;

  text-align: center;
  font-family: "Avenir-Medium";
  font-weight: 400;
  line-height: 30px;
  font-size: 19px;
  letter-spacing: 1px;

  transition: all 0.3s ease-in-out;

  &:active {
    scale: 0.97;
  }
`;
export const LeftButton = styled.button`
  border-radius: 0.4rem;
  width: 100%;
  height: 5rem;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #484888;
  border: none;
  outline: none;

  cursor: pointer;
  user-select: none;
  color: #fff;
  text-align: center;
  font-family: "Avenir-Medium";
  font-weight: "500";
  font-size: 1.6rem;
  letter-spacing: 1px;

  transition: all 0.3s ease-in-out;

  &:active {
    scale: 0.97;
  }
  @media (max-width: 1200px) {
    font-size: 1.4rem;
  }
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4rem;
`;

export const Text = styled.span`
  font-family: "Avenir-Medium";
  font-size: 1.4rem;
  letter-spacing: 0.067px;
`;

export const Input = styled.input`
  font-family: "Avenir-Black";
  user-select: none;
  font-size: 3rem;
  text-align: center;
  color: #85a195;
  line-height: 3.2rem;
  border-top: unset;
  border-left: unset;
  border-right: unset;
  max-width: 10rem;

  border-bottom: 2px solid #85a195;
  width: fit-content;
  &:focus {
    outline: none;
  }
  @media (max-width: 1020px) {
    font-size: 2rem;
    line-height: 2.2rem;
  }
`;

export const StyledTitleContainer = styled(TitleContainer)`
  flex-direction: column;
  gap: 0px;
`;
export const StyledRow = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;
export const Error = styled.span`
  color: #f00;
  font-family: "Avenir-Medium";
  font-size: 1.4rem;
  letter-spacing: 0.067px;
`;
export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  gap: 0.5rem;
  margin-bottom: 3rem;
  margin-top: 6rem;

  @media (max-width: 540px) {
    margin-top: 3rem;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
  @media (max-width: 425px) {
    flex-direction: column;
    justify-content: center;
    gap: 0;
  }
`;
export const StyledSectionTitle = styled(SectionTitle)`
  cursor: ${(props) => (props.$noClick ? "default" : "pointer")};
  &:hover {
    text-decoration: ${(props) => (props.$noClick ? "default" : "underline")};
  }
`;
export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 425px) {
    width: 100%;
    gap: 1rem;
  }
`;
export const FooterText = styled.span`
  color: rgba(0, 0, 0, 0.5);
  font-family: "Avenir-Medium";
  font-size: 1.6rem;
  line-height: 3.2rem; /* 200% */
  @media (max-width: 425px) {
    line-height: normal;
  }
`;
export const FooterValues = styled.span`
  color: #636060;
  font-family: "Avenir-Heavy";
  font-weight: "800";
  font-size: 1.8rem;
`;
export const Green = styled(Text)`
  color: #ea435d;
  font-family: "Avenir-Black";
`;
export const Red = styled(Green)`
  font-family: "FrankfurterEF-Medium";
`;

export const Success = styled.img`
  user-select: none;
  background-color: transparent;
`;

export const ErrorDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-self: center;
  padding-top: 10%;
  padding-bottom: 10%;
  gap: 3rem;
`;

export const SubTitle = styled.span`
  color: #484888;
  font-family: "Avenir";
  font-size: 1.8rem;
  font-weight: 300;
  letter-spacing: -0.178px;
  cursor: pointer;
  text-decoration: underline;
  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const LoaderDiv = styled.div`
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100dvh;
  display: flex;
`;
export const SetPrintArea = styled.div`
  width: 100%;
  height: 100%;

  background-color: transparent;
  border: 1px solid transparent;

  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid white;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;

  pointer-events: none;
  left: 0;
  z-index: 11;
  right: 0;
  bottom: 0;
  background-color: #00bfff40;
`;
export const Overflow = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
`;
export const SetHorizontalLine = styled.div`
  width: 115%;
  height: 1px;
  background-color: white;
  position: absolute;
`;

export const SetVerticalLine = styled.div`
  z-index: 1;
  height: 120%;
  width: 1px;
  background-color: white;
  position: absolute;
`;

export const HorizontalLine = styled.div`
  width: 120%;

  z-index: 1;
  height: 1px;
  background-color: white;
  position: absolute;
  opacity: ${(props) => (props.$hover ? 1 : 0)};
  transition: all 0.1s ease-in-out;
  @media (max-width: 768px) {
    opacity: ${(props) => (props.$drag ? 1 : 0)};
  }
`;

export const VerticalLine = styled.div`
  height: 115%;

  width: 1px;
  background-color: white;
  position: absolute;
  transition: all 0.1s ease-in-out;
  opacity: ${(props) => (props.$hover ? 1 : 0)};
  @media (max-width: 768px) {
    opacity: ${(props) => (props.$drag ? 1 : 0)};
  }
`;
export const PrintArea = styled.div`
  z-index: 2;
  background-color: transparent;
  border: 1px solid transparent;
  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.1s ease-in-out;
  border: ${(props) =>
    props.$hover ? "1px solid white" : "1px solid transparent"};
  @media (max-width: 768px) {
    border: 1px solid white;
  }
`;
export const PrintLogo = styled.img`
  width: 100%;
  height: 100%;
  border: ${(props) =>
    props.$hover ? "1px solid white" : "1px solid transparent"};
  border-style: dashed;
  user-select: none;
  z-index: 4;
  pointer-events: none;
  @media (max-width: 768px) {
    border: 1px solid white;
  }
`;

export const PhotoBorder = styled.div`
  width: 100%;
  height: 100%;
  border: ${(props) =>
    props.$hover ? "1px solid white" : "1px solid transparent"};
  border-style: dashed;
  user-select: none;
  z-index: 4;
  pointer-events: none;
  @media (max-width: 768px) {
    border: 1px solid white;
  }
`;

export const RemoveLogo = styled.div`
  width: 2.2rem;
  height: 2.2rem;
  z-index: 6;
  border-radius: 50%;
  outline: 1px solid white;
  background-color: #ea435d;
  position: absolute;
  top: -1rem;
  right: -1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  transition: all 0.1s ease-in-out;
  opacity: ${(props) => (props.$hover ? 1 : 0)};
  @media (max-width: 768px) {
    opacity: 1;
  }
`;

export const ResizeLogo = styled(RemoveLogo)`
  background-color: #484888;
  top: unset;
  bottom: -1rem;
  padding: 0.3rem;
  cursor: nwse-resize;
  transition: all 0.1s ease-in-out;
  opacity: ${(props) => (props.$hover ? 1 : 0)};
  z-index: 10;
  @media (max-width: 768px) {
    opacity: 1;
  }
`;

export const RotateLogo = styled(ResizeLogo)`
  right: unset;
  left: -1rem;
  cursor: move;
`;

export const LogoContainer = styled.div`
  position: relative;
  cursor: move;
  z-index: 5;
  width: fit-content;

  height: fit-content;
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  /* cursor: pointer; */
  /* min-height: 55rem; */
  /* @media (max-width: 1020px) {
    min-height: 35rem;
  } */
`;

export const StyledDraggable = styled(Draggable)`
  z-index: 5;
`;

export const Dots = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -3rem;
`;

export const Dot = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  cursor: pointer;

  background-color: #484888;
  border: 2px solid #b6b6cf;
  outline: 1px solid #7f7fac;

  opacity: ${(props) => (props.$active ? 1 : 0.25)};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;

  &:hover {
    opacity: 1;
  }
`;

export const PrintAreTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -2.5rem;
  left: 0;
  right: 0;
  padding: 0.2rem;
  z-index: 11;
  background-color: #00bfff;
`;
export const PrintAreaText = styled.span`
  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 1.2rem;
  user-select: none;
  letter-spacing: 0.067px;
`;

export const Div = styled.div`
  z-index: 2;
  background-color: transparent;
  border: 1px solid transparent;
  position: absolute;

  display: flex;

  transition: all 0.1s ease-in-out;
  border: ${(props) =>
    props.$hover ? "1px solid white" : "1px solid transparent"};
  @media (max-width: 768px) {
    border: 1px solid white;
  }
`;

export const PrintAreaBorder = styled.div`
  z-index: 2;
  background-color: transparent;
  border: 1px solid transparent;
  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.1s ease-in-out;
  border: ${(props) =>
    props.$hover ? "1px solid white" : "1px solid transparent"};

  @media (max-width: 1200px) {
    display: none;
  }
  @media (max-width: 768px) {
    border: ${(props) =>
      props.$drag ? "1px solid white" : "1px solid transparent"};
  }
`;

export const PrintAreaContainer = styled.div`
  background-color: transparent;
  position: absolute;
  display: flex;
  border: 1px solid transparent;
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const PrintLogoInvisible = styled(PrintLogo)`
  opacity: 0;
  width: 100%;
  height: 100%;
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #484888;
  padding: 1rem 2rem;
  max-width: 33rem;
  position: absolute;
  left: -2rem;
  z-index: 1000;
  top: -2rem;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
    rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;

  animation: ${(props) => (props.$show ? fadeIn : fadeOut)} 0.3s ease-in-out;
`;

export const PopupTitle = styled.span`
  color: #fff;
  font-family: "Avenir-Heavy";
  font-size: 1.6rem;
  user-select: none;
  letter-spacing: 0.067px;
`;
export const PopupTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const PopupText = styled.span`
  color: #fff;
  font-family: "Avenir-Heavy";
  font-size: 1.6rem;
  user-select: none;
  letter-spacing: 0.067px;
  opacity: 0.8;
`;

export const Triangle = styled.div`
  position: absolute;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 50px 37.5px 0;
  border-color: transparent #484888 transparent transparent;
  transform: rotate(0deg);
  bottom: -2rem;
  right: 0;
`;

export const XIcon = styled(Xsvg)`
  cursor: pointer;
  position: absolute;
  width: 1.6rem;
  top: 0.5rem;
  right: 1rem;
  z-index: 10;

  fill: white;

  &:hover {
    fill: red;
  }
`;
